<template>
  <div class="card" style="min-height: 200px">
    <div class="d-flex justify-content-end mb-2" v-if="selectedPayrollMasterIds.length > 0">
      <button :disabled="saveButtonLoader" class="btn btn-success" @click="handleSubmitStatement">
        Generate Statement
      </button>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th class="text-center">
            <input type="checkbox" @change="toggleSelectAll" :checked="isAllSelected">
          </th>
          <th class="text-center">Payroll Category</th>
          <th class="text-center">Calculation Period</th>
          <th class="text-center">Start Date</th>
          <th class="text-center">End Date</th>
          <th class="text-center">Total Earning</th>
          <th class="text-center">Total Deduction</th>
          <th class="text-center">Total Net Payable</th>
          <th class="text-center">Status</th>
          <th class="text-center">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in payrollProcessList" :key="i">
          <td class="text-center">
            <input type="checkbox" :value="item.id" v-model="selectedPayrollMasterIds">
          </td>
          <td class="text-center text-capitalize">{{ item.payroll_category_name }}</td>
          <td class="text-center">{{ item.payroll_period_name }}</td>
          <td class="text-center">{{ item.payroll_start_date }}</td>
          <td class="text-center">{{ item.payroll_end_date }}</td>
          <td class="text-center">{{ item.total_earning }}</td>
          <td class="text-center">{{ item.total_deduction }}</td>
          <td class="text-center">{{ item.total_net_payable }}</td>
          <td class="text-center text-capitalize">{{ item.payroll_approval_status_name }}</td>
          <td class="text-center">
            <button class="btn btn-primary btn-sm"
                    @click="goToShow(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="payrollProcessList.length < 0" class="text-center mt-5">No data</p>
    </div>

  </div>
  <div class="px-2 position-absolute bottom-0 mt-5">
    <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
  </div>
</template>

<script setup>
import Pagination from '@/components/atom/Pagination'
import {computed, inject, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const saveButtonLoader = ref(false)
const params = ref({
  offset: 20,
});
const payrollProcessList = ref([])
const selectedPayrollMasterIds = ref([])
const {
  fetchPayrollProcessData,
  createPayrollGenerateStatement
} = handleHrPayroll()

const isAllSelected = computed(() => {
  return payrollProcessList.value.length > 0 &&
      selectedPayrollMasterIds.value.length === payrollProcessList.value.length
})

const toggleSelectAll = (event) => {
  selectedPayrollMasterIds.value = []
  if (event.target.checked) {
    selectedPayrollMasterIds.value = payrollProcessList.value.map(item => item.id)
  }
}

const handleSubmitStatement = async () => {
  saveButtonLoader.value = true
  let query = `?company_id=${route.params.companyId}`;
  let data = {}
  data.payroll_master_ids = selectedPayrollMasterIds.value;

  await createPayrollGenerateStatement(data, query).then(res => {
    if (!res.status){
      showError(res.message)
      return
    }

    showSuccess(res.message)
    getPayrollProcessList()
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    saveButtonLoader.value = false
  })
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getPayrollProcessList();
}

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const goToShow = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId,
    payrollMasterId:item.id
  }

  let query = route.query;

  router.push({
    name:  'payroll-view',
    params: param,
    query: query
  })
}

const getPayrollProcessList = async () => {
  let query =`?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&offset=' + params.value.offset
  query += '&approval_status=approved'

  loading.value = true
  payrollProcessList.value = []

  await fetchPayrollProcessData(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    payrollProcessList.value = res.data.data;
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

onMounted(() => {
  Promise.all([
    getPayrollProcessList()
  ])
})

</script>
